import styled from 'styled-components';


export  const Container = styled.div`

background-color: transparent;
height: 100vh;
width: 100%;
display: flex;
justify-content: center;
align-items:center;


.btn{
     background-color: #f85d00;
     border: 0;
     width: 100%;
}

`;


export  const Box = styled.div`


padding: 25px;
background-color: #fff9eb;

min-width:240px;
width:400px;



@media(max-width: 450px){
    width: 100%;

}

`;


export  const Title = styled.p`

color: #f85d00;
width: 100%;

display: flex;
justify-content: center;


`;
export  const FormBox = styled.div`



`;

export  const Logo = styled.img`

width: 218px;


`;
export  const LogoBox = styled.div`

display: flex;
justify-content: center;


`;